import { InputProps, TextField, TextFieldProps } from '@mui/material';
import React from 'react';

import { EntityOnChange } from 'app/type';
import { InputValueUtils } from 'app/utils/input-value-utils';

type EntityTextFieldProps<T> = Omit<TextFieldProps, 'onChange'> & {
    name: keyof T;
    value: T;
    onChange?: EntityOnChange<T>;
};

export const EntityTextField = <T extends object>(props: EntityTextFieldProps<T>): React.ReactElement => {
    const { value, name, onChange, ...rest } = props;

    const handleEntityChange: InputProps['onChange'] = (evt) => {
        onChange?.(evt, evt.target.name as keyof T, evt.target.value);
    };

    // assume developer knows this should be for text style only input
    // save some CPU cycles by avoiding actual type checks.
    const data = value[name] as number | string | undefined;

    return (
        <TextField
            {...rest}
            name={name}
            value={InputValueUtils.optionalToString(data, props.type)}
            onChange={handleEntityChange}
        />
    );
};
